export default __webpack_public_path__ + "locales/sl/WebPlugins.json?hash=9da985496e0e0ec73b5f85194359403f";